import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';


export default {
  name: 'assets',
  components: {
    ElementsSearch: require('../assetsSubComponents/elementsSearch/elementsSearch.vue').default,
    ElementProperties: require('../assetsSubComponents/elementProperties/elementProperties.vue').default,
    TreeSelect: require('../../customcontrols/selectOfTree.vue').default,
  },
  data: function () {
    return {
      thisPage: null,
      propertiesDialogShow: false,
      elementTypeId: 0,
      elementId: 0,
      elementName: '',
      elementProperties: null,
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  created() {
    this.thisPage = this;
    this.$material.locale.dateFormat = 'yyyy-MM-dd';
  },
  mounted() {
    
  },
  methods: {
    viewProperties(elementTypeId, elementId) {
      if (elementTypeId == '' || elementTypeId == null || elementId == '' || elementId == null)
        return;

      this.elementTypeId = elementTypeId;
      this.elementId = elementId;
      this.propertiesDialogShow = true;
    },
  },
}
